const BASEURL = process.env.REACT_APP_BACKEND;

const setBaseUrlPrefix = (path) => {
  return BASEURL.concat(path);
};

const apiOrganizerPathConstants = {
  authOrganizer: {
    loginOrg: setBaseUrlPrefix("/auth/org/login"),
    logoutOrg: setBaseUrlPrefix("/auth/org/logout"),
    registerOrg: setBaseUrlPrefix("/auth/org/register"),
    sendEmailOrg: setBaseUrlPrefix("/auth/org/send/verification-email"),
    verifyEmailOrg: setBaseUrlPrefix("/auth/org/verify-email"),
    forgotPasswordOrg: setBaseUrlPrefix("/auth/org/forgot-password"),
    resetPasswordTokenOrg: setBaseUrlPrefix("/auth/org/reset-password"),
    changePassword: setBaseUrlPrefix("/auth/org/change-password"),
    verifySessionOrg: setBaseUrlPrefix("/auth/org/verify"),
    updateProfileOrg: setBaseUrlPrefix("/auth/org/organizer"),
    getSetupStatus: setBaseUrlPrefix("/auth/org/organizer/setup-status"),
    updateSetup: setBaseUrlPrefix("/auth/org/organizer/setup"),
  },
  offers: {
    getOffers: setBaseUrlPrefix("/organizer/offers"),
    getOfferById: (offerId) =>
      setBaseUrlPrefix(`/organizer/offers/${encodeURIComponent(offerId)}`),
    createOffer: setBaseUrlPrefix("/organizer/offers"),
    updateOffer: (offerId) =>
      setBaseUrlPrefix(`/organizer/offers/${encodeURIComponent(offerId)}`),
    deleteOffer: (offerId) =>
      setBaseUrlPrefix(`/organizer/offers/${encodeURIComponent(offerId)}`),
  },
  dashBoardOrganizer: {
    getOrganizerDashboard: setBaseUrlPrefix("/org/orgDashboard"),
  },

  supportTicketOrg: {
    getTicketListOrg: setBaseUrlPrefix("/support/ticketsListOrg"),
    addTicketOrg: setBaseUrlPrefix("/support/addTicketOrg"),
  },

  bookingOrg: {
    getBookingDetail: (booking_id) =>
      setBaseUrlPrefix(`/bookings/organizer/booking/${booking_id}`),
    getOrganizerBooking: setBaseUrlPrefix("/bookings/allBookingOrganizer"),
    getReportOrganizer: setBaseUrlPrefix("/bookings/bookingReportOrg"),
    getMerchandiseReportOrganizer: setBaseUrlPrefix("/bookings/merchandiseReportOrg"),
    resendTicket: setBaseUrlPrefix("/bookings/resend-ticket"),
    refundTicket: setBaseUrlPrefix("/bookings/refund-ticket"),
  },
  coupons: {
    addCoupon: setBaseUrlPrefix("/coupon/create-coupon"),
    editCoupon: setBaseUrlPrefix("/coupon/edit-coupon"),
    deleteCoupon: setBaseUrlPrefix("/coupon/delete-coupon"),
    orgCouponsList: setBaseUrlPrefix("/coupon/org-coupons"),
    userCoupons: setBaseUrlPrefix("/coupon/user-coupons"),
    applyCoupon: setBaseUrlPrefix("/coupon/apply"),
  },
  payout: {
    fetchSummary: setBaseUrlPrefix("/organizer/payouts/summary"),
    fetchUpcoming: setBaseUrlPrefix("/organizer/events/upcoming"),
    togglePayoutMode: (eventRef) =>
      setBaseUrlPrefix(
        `/organizer/events/${encodeURIComponent(eventRef)}/payout-mode`,
      ),
    fetchProjectedPayout: (type, eventRef) =>
      setBaseUrlPrefix(
        `/organizer/payouts/future?type=${encodeURIComponent(
          type,
        )}&eventRef=${encodeURIComponent(eventRef)}`,
      ),
    createPayout: setBaseUrlPrefix("/organizer/payouts"),
    previewPayout: setBaseUrlPrefix("/organizer/payouts/preview"),
    fetchPayoutHistory: (page, limit) =>
      setBaseUrlPrefix(
        `/organizer/payouts?page=${encodeURIComponent(
          page,
        )}&limit=${encodeURIComponent(limit)}`,
      ),
    fetchEventPayoutSummary: setBaseUrlPrefix("/organizer/payouts/event/summary"),
  },
  scanner: {
    register: setBaseUrlPrefix("/organizer/scanners/register"),
    resendActivation: setBaseUrlPrefix("/organizer/scanners/resend-activation"),
    updateStatus: (id) =>
      setBaseUrlPrefix(`/organizer/scanners/${encodeURIComponent(id)}/status`),
    createPermission: setBaseUrlPrefix("/organizer/scanners/permissions"),
    updatePermission: (id) =>
      setBaseUrlPrefix(
        `/organizer/scanners/permissions/${encodeURIComponent(id)}`,
      ),
    revokePermission: (id) =>
      setBaseUrlPrefix(
        `/organizer/scanners/permissions/${encodeURIComponent(id)}`,
      ),
    assignAllUpcomingEvents: (id) =>
      setBaseUrlPrefix(
        `/organizer/scanners/${encodeURIComponent(id)}/assign-all-upcoming`,
      ),
    getScanners: setBaseUrlPrefix("/organizer/scanners"),
  },
};

export default apiOrganizerPathConstants;
